import React from 'react'
import clsx from 'clsx'

interface OntologyTagProps {
  className_name: string
  prefix?: string
  size?: 'sm' | 'md'
  variant?: 'purple' | 'blue' | 'green'
}

const variantStyles = {
  purple: 'bg-purple-50 text-purple-700 border-purple-200',
  blue: 'bg-blue-50 text-blue-700 border-blue-200',
  green: 'bg-emerald-50 text-emerald-700 border-emerald-200',
}

export default function OntologyTag({
  className_name,
  prefix = 'math',
  size = 'sm',
  variant = 'purple',
}: OntologyTagProps) {
  return (
    <span className={clsx(
      'font-mono border rounded px-1.5 py-0.5 inline-flex items-center gap-0.5',
      size === 'sm' ? 'text-xs' : 'text-sm',
      variantStyles[variant],
    )}>
      <span className="opacity-60">{prefix}:</span>
      <span className="font-semibold">{className_name}</span>
    </span>
  )
}
